export const SignupRequestStatus = {
  Pending: 1,
  Rejected: 2,
  Approved: 3,
};
